(function ($) {

    this.init = function () {
        this.BlogMain();
    };

    this.BlogMain = function () {

        $(".blog-main-jumplink").on("click", function () {
            var animationTime = 400 + ($(this).index() * 200);
            var target = $($(this).attr("data-anchor"));
            $("html, body").stop().animate({
                scrollTop: target.offset().top - $(".headernavfull").outerHeight() - 20
            }, animationTime);
        });

    }
    this.init();

})(jQuery);